import {Component} from '@angular/core';
import {Location} from "@angular/common";

@Component({
  selector: 'app-page-500',
  templateUrl: './page-500.component.html',
  styleUrls: ['./page-500.component.css'],
  host: {
    class: 'app-page'
  }
})
export class Page500Component {
  constructor(private readonly location: Location) {
  }

  back(): void {
    this.location.back();
  }
}
